// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__21Ksv","bounce":"Loader_bounce__3hL-4"};